<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const props = defineProps({
  installment: { type: Object, default: null },
});

const emit = defineEmits(['cancel', 'status']);
const { t } = useI18n();
const detail = computed(() => props.installment || {});
const status = computed(() => detail.value.parcela?.status || {});
const lastUpdated = computed(() => {
  const value = detail.value.parcela?.ultima_data_envio;
  return value
    ? String(value).slice(0, 16)
    : t('REAL_ESTATE_FINANCE.TABLE.EMPTY_VALUE');
});
const statusClass = color =>
  ({
    neutral: 'bg-slate-100 text-slate-700',
    yellow: 'bg-yellow-100 text-yellow-800',
    primary: 'bg-blue-100 text-blue-800',
    green: 'bg-emerald-100 text-emerald-800',
    red: 'bg-red-100 text-red-800',
  })[color] || 'bg-slate-100 text-slate-700';
</script>

<template>
  <section
    data-testid="finance-installment-payment-status"
    class="rounded-lais border border-lais-border-soft bg-white p-4 shadow-lais-card"
  >
    <header class="flex flex-wrap items-center justify-between gap-3">
      <div class="flex items-center gap-2">
        <span
          class="i-lucide-refresh-cw size-5 text-lais-primary"
          aria-hidden="true"
        />
        <h2 class="font-semibold text-lais-text">
          {{ t('REAL_ESTATE_FINANCE.DETAIL.PAYMENT_STATUS_TITLE') }}
        </h2>
      </div>
      <p
        class="text-[11px] font-semibold uppercase tracking-wide text-lais-text-muted"
      >
        {{ t('REAL_ESTATE_FINANCE.DETAIL.LAST_UPDATE') }} {{ lastUpdated }}
      </p>
    </header>
    <div
      class="mt-4 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between"
    >
      <div class="flex flex-wrap items-center gap-2 text-sm">
        <span class="text-lais-text-muted">
          {{ t('REAL_ESTATE_FINANCE.DETAIL.SALE_STATUS') }}
        </span>
        <span
          class="inline-flex rounded-full px-2 py-1 text-xs font-bold"
          :class="statusClass(status.color)"
        >
          {{ status.label || t('REAL_ESTATE_FINANCE.TABLE.EMPTY_VALUE') }}
        </span>
      </div>
      <div class="flex flex-wrap gap-2">
        <LaisPrimaryButton
          v-if="detail.acoes?.pode_cancelar"
          class="border-red-200 !text-lais-danger hover:!border-red-300"
          size="sm"
          variant="ghost"
          @click="emit('cancel')"
        >
          {{ t('REAL_ESTATE_FINANCE.DETAIL.CANCEL') }}
        </LaisPrimaryButton>
        <LaisPrimaryButton
          v-if="detail.acoes?.pode_alterar_status"
          size="sm"
          variant="primary"
          @click="emit('status')"
        >
          {{ t('REAL_ESTATE_FINANCE.STATUS.CHANGE') }}
        </LaisPrimaryButton>
      </div>
    </div>
  </section>
</template>
